<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('sale_receipt') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> {{ $t('back') }}</button>
            <router-link to="/sale/receipt-create" class="btn btn-outline-primary btn-sm no-bor">
                <i class="fa fa-plus" aria-hidden="true"></i>
                {{$t('add_new')}}
            </router-link>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="exportExcel">
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                {{$t('export_excel')}}
            </button>
            <router-link to="/sale/receipt/pending-invoices" class="btn btn-outline-primary btn-sm no-bor">
                <i class="fa fa-clock-o" aria-hidden="true"></i>
                {{$t('pending_invoice')}}
            </router-link>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row-flex-x">
                        <div class="form-group">
                            <label class="label-control">&nbsp;</label>
                            <div>
                                <input type="text" class="form-control form-control-sm" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>
                            </div>
                        </div>                        
                        <DatePicker v-model="query.FromDate" :label="$t('from_date')"/>
                        <DatePicker v-model="query.ToDate" :label="$t('to_date')"/>                            
                        <div class="form-group">
                            <label class="label-control">&nbsp;</label>
                            <div>
                                <button type="button" class="btn btn-default btn-sm" @click="toList"><i class="fa fa-search" aria-hidden="true"></i> {{$t('search')}}</button>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                        <tr>
                            <th style="width: 50px;" class="text-center">{{ $t('no') }}</th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('Num')">{{ $t('receipt_no') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('Date')">{{ $t('date') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('CustomerName')">{{ $t('customer') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('AccountName')">{{ $t('payment_method') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('Description')">{{ $t('description') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="text-right">{{ $t('amount') }}</th>
                            <th style="width: 60px;"></th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in records" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td>{{ret.Num}}</td>
                                <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                                <td>{{ret.CustomerName}}</td>
                                <td>{{ret.AccountName}}</td>
                                <td>{{ret.Description}}</td>
                                <td class="text-right">{{$money(ret.Amount)}}</td>
                                <td class="text-center">
                                    <div class="cell-action">
                                        <router-link :to="{name: 'sale_receipt_preview', params: {id: ret.Id}}" class="btn btn-outline-info btn-sm btn-xs"><i class="fa fa-eye" aria-hidden="true"></i></router-link>
                                        <router-link :to="{ name: 'sale_receipt_print', params: { id:ret.Id }}" target="_blank" class="btn btn-outline-info btn-sm btn-xs"><i class="fa fa-print"></i></router-link>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colspan="6"></th>
                                <th class="text-right">{{$money(summary.Total)}}</th>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DatePicker from "../Components/DatePicker.vue";     
    export default {
        components: {
            DatePicker
        },
        data: function(){
            return {
                query:{
                    Text: '',
                    FromDate: '',
                    ToDate: '',
                    Page: 1,
                    Total: 0,
                    Limit: 25,
                    CompanyId: this.$store.state.company.Id
                },
                records:[],
                summary: {
                    Total: 0
                }
            }
        },
        created: function(){
            this.toList();
        },
        methods: {
            toList(){
                var loading = this.$loading.show();
                this.$api().post('sale/receipts', this.query).then((res) => {
                    if(this.$isValid(res)){
                        this.records = res.data.Data;
                        this.calculate();
                    }
                }).finally(function() { loading.hide(); });
            },
            calculate(){
                let total = 0;
                this.records.forEach(item => {
                    total += item.Amount;
                });
                this.summary.Total = total;
            },
            exportExcel(){
                var loading = this.$loading.show();
                this.$api()({
                    url: this.$base() + 'sale/receipts/export/excel',
                    method: 'post',
                    data: this.query,
                    responseType: 'blob'
                }).then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'sale-receipts.xlsx');
                    document.body.appendChild(link);
                    link.click();
                }).finally(function(){ loading.hide();});
            },
            onSort(field){
                this.query.SortField = field;
                if(this.query.SortType == 'ASC') this.query.SortType = 'DESC';
                else this.query.SortType = 'ASC';
                this.toList();
            },
            paging(e){
                this.query.Page = e;
                this.toList();
            },
        }
    }
</script>
